

















































import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import ProjectList from "../components/projects/project-list.vue";

export default Vue.extend({
  components: { ProjectList },
  data() {
    return {
      isCollapsed: false,
      personalProjectFilter: "All Projects",
      selectedMemberId: NaN,
      showFilterPoptip: false,
      userId: 1,
      name: "Test",
      email: "test@gmail.com",
      phone: 111 - 111 - 1111,
    };
  },
  computed: {
    ...mapState("project", ["loading"]),
    ...mapGetters("project", ["canAdd"]),
    ...mapState("session", ["user", "billingAccountIdChangedCount", "billingAccounts"]),
    ...mapState("billing", ["billingAccount"]),
    ...mapGetters("billing", ["hasAccountAdminPermission", "hasUserManagementPermission"]),
    hashTags() {
      let hashTags = ["All Projects", "Active Projects", "Completed Projects"];
      let allProjects = this.$store.state.project.myProjects || [];
      allProjects.forEach((project) => {
        hashTags = hashTags.concat(project.hashTagList.map((tag) => "#" + tag.text));
      });
      return [...new Set(hashTags)];
    },
    members() {
      let context = this as any;
      return context.billingAccount ? context.billingAccount.members : [];
    },
  },
  watch: {
    billingAccountIdChangedCount(newVal) {
      this.$store.dispatch("project/getMyProjects", {});
    },
    user(newVal) {
      let context = this as any;
      if (newVal) {
        context.selectedMemberId = newVal.id;

        (this as any).$intercom.boot({
          user_id: (this as any).user.id,
          user_hash: (this as any).user.intercomUserHash,
          name: (this as any).user.name,
          email: (this as any).user.emailAddress,
          phone: (this as any).user.phoneNumber,
        });
        (this as any).$intercom.show();
      }
    },
    email(email) {
      (this as any).$intercom.update({ email });
    },
  },
  created() {
    this.$store.dispatch("project/getMyProjects", {});
  },
  mounted() {
    let context = this as any;
    if (context.user) {
      context.selectedMemberId = context.user.id;
    }
  },
  methods: {
    handleAddProject() {
      (this.$refs.ProjectList as any).showProjectCreator();
    },
    getUserTitle(user) {
      let roleName = "User";
      switch (user.role) {
        case 1:
          roleName = "Admin";
          break;
        case 2:
          roleName = "Manager";
          break;
        case 3:
          roleName = "User";
          break;
        default:
          roleName = "User";
          break;
      }

      //return `${user.memberName} - ${roleName}`;
      return `${user.memberName}`;
    },
  },
});
